import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
// import createHistory from 'history/createBrowserHistory';
import InputBox from './InputBox';
import _ from 'lodash';
import '../css/SystemIntegratorEdit.css';
import ErrorText from '../ErrorText';
import cities from './cities';
import Loader from './Loader';
import SnackBar from './SnackBar';
import { MenuItem, TextField } from '@mui/material';

//Distributor edit page  component
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '90%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const customStylesSuccess = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

const SiRating = [
  { label: 'A++' },
  { label: 'A' },
  { label: 'B+' },
];

const SiRelationStat = [
  { label: 'Hot' },
  { label: 'Warm' },
  { label: 'Dry' },
  { label: 'Cold' },
];


export default class SystemIntegratorEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.activeModal,
      modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
      noOfParams: [],
      SiName: this.props.siCurrentData.si_name,
      SiEmail: this.props.siCurrentData.si_email,
      SiCompany: this.props.siCurrentData.si_company,
      SiMobile: this.props.siCurrentData.si_mobile,
      SiArea: this.props.siCurrentData.si_area,
      SiAddress: this.props.siCurrentData.si_address,
      SiGST: this.props.siCurrentData.si_gstin,
      DistributorCountry: this.props.siCurrentData.si_country ? this.props.siCurrentData.si_country : "N/A",
      errorMessage: [],
      modalIsOpenSuccess: false,
      loader: false,
      disableSave: true,
      snackbarActive: false,
      snackbarMessage: '',
      siData: [],

    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);

  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }


  closeModalSuccess() {
    this.setState({
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpenSuccess: false
        }, () => {
          this.props.closeAllModal()
        })
      }, 500);

    })
  }
  afterOpenModal() {
  }

  closeModal() {
    this.setState({
      modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpen: false
        }, () => {
          this.props.closeAllModal()
        })
      }, 500);

    })
  }

  onSelectChange = (operationMode, valueSelect) => {
    if (operationMode === 'rating') {
      this.setState({
        SiRating: valueSelect.value,
        errorMessage: [],
        disableSave: false
      })
    }
    if (operationMode === 'relationStat') {
      this.setState({
        SiRelationStat: valueSelect.value,
        errorMessage: [],
        disableSave: false
      })
    }
    // if (operationMode === 'siArea') {
    //   this.setState({
    //     SiArea: valueSelect.value,
    //     errorMessage: [],
    //     disableSave: false
    //   })
    // }

    if (operationMode === 'distributorCountry') {
      const isIndia = valueSelect === 'India';
      this.setState({
        DistributorCountry: valueSelect,
        showIndiaFields: isIndia,
        SiArea: isIndia ? this.state.SiArea : '',
        SiGST: isIndia ? this.state.SiGST : '',
        errorMessage: []
      });
    }

    if (operationMode === 'siArea') {
      this.setState({
        SiArea: valueSelect,
        errorMessage: []
      }, () => {
        // console.log("SiArea is now:", this.state.SiArea);
      });
    }
  }

  componentDidMount() {
    this.fecthAllSI();
    let cityNew = [];
    cities.map((e) => {
      let newCity = {
        "label": `${e.city}, ${e.state}`
      }
      cityNew.push(newCity);
    })
    this.setState({
      indianCityWithState: cityNew
    }, () => console.log(this.state.indianCityWithState))
  }

  fecthAllSI = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/distributors/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        // console.log(data);

        this.setState({
          siData: data.data

        })
        //  console.log(this.state.siData);  // Check Get distributors data
      })
      .catch((err) => {
        console.log(err)

      })
  }



  onEditFinal = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    let si_name = this.state.SiName;
    let si_email = this.state.SiEmail;
    let si_company = this.state.SiCompany;
    let si_country = this.state.DistributorCountry;
    let si_mobile = this.state.SiMobile;
    let si_area = this.state.SiArea;
    let si_address = this.state.SiAddress;
    let si_gstin = this.state.SiGST;

    fetch(`/cloud/distributors/?si_id=${this.props.siCurrentData.si_id}`, {

      method: "PUT",
      headers: headers,
      body: JSON.stringify({
        si_name,
        si_email,
        si_company,
        si_country,
        si_mobile,
        si_area,
        si_address,
        si_gstin
      })
    })

      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        let rawData = data;
        data = data.data
        let index = Object.keys(data)[0]
        //  console.log(index + ": " + data[Object.keys(data)[0]])
        let errorLog = index + ": " + data[Object.keys(data)[0]]
        if (rawData.message !== 'failure') {
          this.setState({
            modalIsOpen: false,
            loader: false
          }, () => {
            this.setState({
              modalIsOpenSuccess: true,
            })
          })
        } else {
          this.setState({
            loader: false,
            snackbarActive: true,
            snackbarMessage: errorLog
          })
          //console.log('put request:', this.state.data)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleChangeInputBox = (name, event) => {
    this.setState({
      [name]: event,
      disableSave: false,

    });
  };

  onEdit = () => {
    //console.log('Editing ID:', this.props.siCurrentData.si_id);
    this.setState({
      showErrorMessage: true
    }, () => {
      this.fetchError((e) => {
        if (e === 'NoError') {
          this.setState({
            loader: true,
            disableSave: true
          }, () => this.onEditFinal())
        }
      })
    })
  }


  fetchError = (noError) => {
    let totalError = 0;

    const { SiName, SiEmail, SiMobile, SiAddress, SiArea, DistributorCountry, SiGST, showIndiaFields } = this.state;

    if (ErrorText('notEmpty', SiName) !== 'No Error') totalError++;
    if (ErrorText('email', SiEmail) !== 'No Error') totalError++;
    if (ErrorText('isMobile', SiMobile) !== 'No Error') totalError++;
    if (ErrorText('notEmpty', SiAddress) !== 'No Error') totalError++;
    if (ErrorText('notEmpty', DistributorCountry) !== 'No Error') totalError++;

    if (showIndiaFields) {
      if (ErrorText('notEmpty', SiArea) !== 'No Error') totalError++;
      if (ErrorText('gst', SiGST) !== 'No Error') totalError++;
    }

    if (totalError === 0) {
      noError('NoError');
    }
  };

  render() {
    // console.log(this.state.DistributorCountry);
    return (
      <React.Fragment>
        {this.state.loader ? <Loader /> : null}
        <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
          this.setState({
            snackbarActive: false
          })
        }} message={this.state.snackbarMessage} />
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>Edit Distributor</h3>
          <div className="row">
            <div className="col-6 disableEvent" style={{paddingLeft: '7px', pointerEvents: 'none' }}>
              <InputBox
                inputText={this.state.SiName}
                error={ErrorText('notEmpty', this.state.SiName) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('notEmpty', this.state.SiName) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the Distributor Name' : ''}
                placeholder="Distributor Name:"
                inputBoxName="SiName"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={50}
                validate={true}
              />
            </div>
            <div className="col-6  mx-0 px-0 disableEvent" style={{ pointerEvents: 'none' }}>
              <InputBox
                inputText={this.state.DistributorCountry}
                error={ErrorText('notEmpty', this.state.DistributorCountry) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('notEmpty', this.state.DistributorCountry) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the Distributor Country' : ''}
                placeholder="Distributor Country"
                inputBoxName="DistributorCountry"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={50}
                validate={true}
              />
            </div>
            {this.state.showIndiaFields && (
              <div className="col-6  text-field-modal" style={{ paddingLeft: '9px', paddingRight: '5px', marginTop: '12px' }} >
                <IntegrationReactSelectNew
                  placeholder=""
                  multipleSelect={false}
                  content={this.state.indianCityWithState}
                  onSelect={this.onSelectChange.bind(this, 'siArea')}
                  IntegrationReactSelectNewLabel="Distributor Area"
                  errorText={this.state.SiArea === '' && this.state.showErrorMessage ? 'Please select the SI Area' : ''}
                  someText={this.state.SiArea}
                />
              </div>)}
            <div className="col-6" style={{paddingLeft: '7px',}}>
              <InputBox
                inputText={this.state.SiAddress}
                error={ErrorText('notEmpty', this.state.SiAddress) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('notEmpty', this.state.SiAddress) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the Distributor Address' : ''}
                placeholder="Distributor Address"
                inputBoxName="SiAddress"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={255}
                validate={true}
              />
            </div>
            <div className="col-6  mx-0 px-0 disableEvent " style={{ pointerEvents: 'none' }}>
              <InputBox
                inputText={this.state.SiEmail}
                error={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Distributor Email' : ''}
                placeholder="Distributor Email: abc@gmail.com"
                inputBoxName="SiEmail"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={255}
                blockSpecialChar={false} // ✅ prevent special char input
              />

            </div>
            {this.state.showIndiaFields && (
              <div className="col-6 px-0" style={{ marginTop: '1px', pointerEvents: 'none' }}>
                <InputBox
                  inputText={this.state.SiGST}
                  error={ErrorText('gst', this.state.SiGST) !== 'No Error' && this.state.showErrorMessage ? true : false}
                  errorText={ErrorText('gst', this.state.SiGST) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Distributor GST of 15 characters in format of 29ABCDE1234F2Z5' : ''}
                  placeholder="Distributor GST"
                  inputBoxName="SiGST"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  textLength={15}
                  validate={true}
                />
              </div>)}
            <div className="col-6" style={{paddingLeft: '7px',}}>
              <InputBox
                inputText={this.state.SiMobile}
                error={ErrorText('isMobile', this.state.SiMobile) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('isMobile', this.state.SiMobile) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Distributor Mobile of 6-15 digits' : ''}
                isNumber={true}
                placeholder="Distributor Mobile"
                inputBoxName="SiMobile"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={15}
                validate={true}
              />
            </div>
            <div className="col-6  mx-0 px-0" style={{ pointerEvents: 'none' }}>
              <InputBox
                inputText={this.state.SiCompany}
                error={ErrorText('notEmpty', this.state.SiCompany) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('notEmpty', this.state.SiCompany) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the Distributor Company' : ''}
                placeholder="Distributor Company"
                inputBoxName="SiCompany"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={100}
                validate={true}
              />
            </div>
          </div>
          <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
            <div className="btn btn-new-grey" onClick={this.closeModal} style={{ marginRight: '15px' }} >Cancel</div>
            <div className="btn btn-new-green" onClick={() => {
              if (!this.state.disableSave) {
                this.onEdit()
              }
            }
            }
              style={{
                cursor: this.state.disableSave ? 'not-allowed' : '',
              }}
            >Save Changes</div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalSuccess}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Distributor edited successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn btn-new-grey"
              onClick={this.closeModalSuccess}>
              Close
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
